import React from 'react';
import { FillContainer } from '@layout';
import { H2 } from '@heading';
import styles from './Scholars.module.scss';

export default function Scholars() {
  return (
    <FillContainer
      tag="section"
      rightAlignDots
      showDots
    >
      <div className={styles.top}>
        <H2>Meet a few of our scholars</H2>
        <p>
          The dedication of our current and former students has helped
          build CDLS into what it is today. The scholars below represent
          just a portion of the many talented scholars on our team.
        </p>
      </div>

      {data.map((p, index) => (
        <Bio
          key={index}
          {...p}
        />
      ))}
    </FillContainer>
  );
}

function Bio({ name, pronouns, title, photo, text }) {
  return (
    <div className={styles.bio}>
      <div
        className={styles.photo}
        style={{ backgroundImage: photo ? `url('${photo}')` : null }}
      />
      <div className={styles.content}>
        <div className={styles.title}>
          {name && <h3>{name}</h3>}
          <div className={styles.info}>
            {pronouns && <span>{pronouns}</span>}
            {title && <span>{title}</span>}
          </div>
        </div>
        {text && (
          <div className={styles.text}>
            {text.split('\n').map((t, i) => (
              <p key={i}>{t}</p>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

const data = [
  {
    name: 'Rae Spriggs',
    pronouns: 'She/Hers',
    title: 'Early Career Fellow',
    photo: require('./images/rae-spriggs.jpg'),
    text:
      'Rae recently earned her Environmental Health Sciences MPH from UCLA. As a CDLS Fellow, she researched Health Impact Assessments (HIA). These are evidence-based tools used to inform stakeholders and decision makers about the potential impacts of proposed policies and projects and identify ways to maximize the health benefits and minimize harm. She reviewed the 96 transportation-related HIAs conducted in the United States to evaluate how they operationalized health equity, a core principle of HIA. This research has been personally meaningful to her as a black woman from a low-income background. She grew up directly next to a major freeway in San Diego, and was diagnosed with asthma at the age of three. In undergrad, she learned that the natural and built environments have significant impacts on our physical health and well-being, and that knowledge has fueled her work since. She now works as a Strategy Specialist with CDLS helping to build, fund, and advance programs and partnerships related to environmental and climate justice.'
  },
  {
    name: 'Venezia Ramirez',
    pronouns: 'She/Hers',
    title: 'Early Career Fellow',
    photo: require('./images/venezia-ramirez.jpg'),
    text:
      'Venezia is a Chicanx 3rd-year undergraduate student studying Environmental Science and is a K-12 outreach coordinator. She is involved in multiple collaborative research projects, including phytoremediation of contaminated soils and waters in East LA. Venezia hopes to enter government to make sustainability more inclusive of underrepresented communities and remove the environmental hazards disproportionately faced by communities of color.'
  },
  {
    name: 'De’Marcus Robinson',
    pronouns: 'He/Him',
    title: 'Early Career Fellow',
    photo: require('./images/demarcus-robinson.jpg'),
    text:
      'De’Marcus is a graduate student in Atmospheric and Oceanic Sciences with a concentration in biological oceanography. His research examines biogeochemical cycles in regions of the ocean with little to no oxygen. By studying the microbes that affect these regions, he hopes to understand how climate change impacts microbes, how pollution affects organic matter and nutrient delivery, and how the culmination of these impacts oxygen levels and ocean health. He is active in outreach to low-income communities impacted by pollution. De’Marcus hopes to gain experience at NOAA, and ultimately to become a professor at a Historically Black College or University (HBCU) and inspire others to enter marine science.'
  },
  {
    name: 'Ronald Thompson III',
    pronouns: 'He/Him',
    title: 'Early Career Fellow',
    photo: require('./images/ronnie-thompson.jpg'),
    text:
      'Ronnie is a 2nd-year undergraduate in Environmental Science with a concentration in Conservation Biology. He is an organizer for Diversi-Tea and the President of the Congo Basin Institute Club, focused on conservation in Cameroon. Ronnie was part of a team working at the UC Natural Reserve system studying community behavior and interactions between pollinators and flowering plants. A future goal of his is to develop and apply isotopic tools for use in studies of bird ecology and conservation.'
  },
  {
    name: 'Lauren Santi',
    pronouns: 'She/Hers',
    title: 'Early Career Fellow',
    photo: require('./images/lauren-santi.jpg'),
    text:
      'Lauren recently graduated with a Master’s degree in Geochemistry. Her research focused on reconstructions of past changes in climate and water in the southwest using multidisciplinary approaches. Lauren contributed to creating the CDLS program Environmental Justice and First Nations, which included taking students from NTU out into the field to gain research experience sampling and mapping ancient shorelines to study the impacts of climate change.'
  },
  {
    name: 'Randy Flores',
    pronouns: 'She/Hers',
    title: 'Early Career Fellow',
    photo: require('./images/randy-flores.jpg'),
    text:
      'Randy graduated from UCLA in 2018 with a B.S. in Geology. He was a community college transfer student and graduated valedictorian in his department. Randy is engaged in laboratory tours and also in community college outreach. His research includes working with a team studying how the chemistry of shells of marine planktonic organisms are linked to ocean temperature and pH.'
  }
];
